import useEsgTree from '@/components/dashboardPage/hooks/useEsgTree';
import EsgTreemap from './components/esgTreemap/EsgTreemap';
import { TreemapWrapper, PreloaderWrapper } from './TreemapStyles';
import Preloaer from '@/ui/preloaders/componentPreloader/ComponentPreloader';

const Treemap = ({ corpcodes }) => {
  const [esgTreemapData] = useEsgTree(corpcodes);

  return (
    <>
      {esgTreemapData ? (
        <div className="p-4">
          <EsgTreemap data={esgTreemapData} isLoading={false} />
        </div>
      ) : (
        <PreloaderWrapper>
          <Preloaer sx={{ height: '465px' }} />
        </PreloaderWrapper>
      )}
    </>
  );
};

export default Treemap;
